import { forwardRef, MouseEvent, ReactNode } from 'react';
import { Disableable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { FilterChipButton, FilterChipIconButton, FilterChipText } from './style';

export interface FilterChipProps extends Disableable {
    children: ReactNode;
    value?: string;
    onClick?: (event: MouseEvent, value: string) => void;
    active?: boolean;
    icon?: IconName;
    size?: 'small' | 'medium';
    ellipsis?: boolean;
    forwardedRef?: React.Ref<HTMLButtonElement>;
}

const FilterChipComponent = ({
    children,
    value = '',
    onClick,
    disabled = false,
    active,
    icon,
    size = 'small',
    ellipsis = true,
    forwardedRef,
    ...other
}: FilterChipProps) => {
    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event, value);
    };

    return (
        <FilterChipButton
            disabled={disabled}
            {...other}
            data-test-button-click
            onClick={handleOnClick}
            active={active}
            size={size}
            ref={forwardedRef}
            type="button"
            aria-pressed={active}
            {...other}
        >
            <FilterChipText
                as="div"
                data-test-filter-chip-text
                ellipsis={ellipsis}
                textStyle={size === 'small' ? 'bodyMedium' : 'bodyLarge'}
                disabled={disabled}
            >
                {children}
            </FilterChipText>
            {icon ? <FilterChipIconButton value={icon} size="small" disabled={disabled} aria-hidden="true" /> : null}
        </FilterChipButton>
    );
};

export const FilterChip = forwardRef<HTMLButtonElement, FilterChipProps>((props, ref) => (
    <FilterChipComponent {...props} forwardedRef={ref} />
));
